import { DeclarationPropertiesTypes } from "../../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../../data/operationRequestData";
import { OperationModel } from "../../operations/operationModel";
import { PersonInfoModel } from "../../person/personInfoModel";

/** Модель ссмены пароля */
export class C2BBindingOperationModel extends OperationModel {

  public DebitAccount: string = '';
  public SbpOperationId: string = '';
  public RedirectUrl: string = '';
  public BankName: string = '';
  public LegalName: string = '';
  public MerchantName: string = '';
  public MerchantInfo: string = '';
  public Success: boolean = true;
  public EnableSbpOut: boolean = true;
  public EnableSbpIn: boolean = true;
  public QrId: string = "";
  public IsBindingNameExists: boolean = false;

  constructor(personInfo: PersonInfoModel, qrId: string, ord: OperationRequestData) {
    super();
    if (personInfo.Data.DefaultOutAccount) {
      this.DebitAccount = personInfo.Data.DefaultOutAccount;
    }
    this.EnableSbpOut = personInfo.Data.EnableSbpOut;
    this.EnableSbpIn = personInfo.Data.EnableSbpIn;

    if (qrId)
      this.QrId = qrId;
    else {
      this.SbpOperationId = ord.getPropertyValue('sbpID');
      this.RedirectUrl = ord.getPropertyValue('redirectUrl');
      this.MerchantInfo = ord.getPropertyValue('subscriptionComment');
      this.BankName = ord.getPropertyValue('bankName');
      this.LegalName = ord.getPropertyValue('receiverName');
      this.MerchantName = ord.getPropertyValue('merchantName');
    }
  }


  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;

    if(this.QrId) {
      ord.setProperty("qrId", this.QrId, DeclarationPropertiesTypes.String);
    } else {
      ord.setProperty("sbpID", this.SbpOperationId, DeclarationPropertiesTypes.String);
      ord.setProperty("result", this.Success.toString(), DeclarationPropertiesTypes.String);
      ord.setProperty("enableIn", this.EnableSbpIn.toString(), DeclarationPropertiesTypes.String);
      ord.setProperty("binding", '', DeclarationPropertiesTypes.String);
      ord.setProperty("contract", this.DebitAccount, DeclarationPropertiesTypes.String);
      ord.setProperty("bindingName", this.MerchantName, DeclarationPropertiesTypes.String);
      ord.setProperty("merchantName", this.MerchantName, DeclarationPropertiesTypes.String);
      ord.setProperty("merchantInfo", this.MerchantInfo, DeclarationPropertiesTypes.String);
      ord.setProperty("maxSum", '', DeclarationPropertiesTypes.String);
    }

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(ord: OperationRequestData): void {
    this.QrId = "";
    const bindingName: string = ord.getPropertyValue("bindingName");

    if(bindingName) {
      this.IsBindingNameExists = true;
      this.MerchantName = ord.getPropertyValue("merchantName");
      this.MerchantInfo = ord.getPropertyValue("merchantInfo");
    } else {
      this.SbpOperationId = ord.getPropertyValue('sbpID');
      this.RedirectUrl = ord.getPropertyValue('redirectUrl');
      this.MerchantInfo = ord.getPropertyValue('subscriptionComment');
      this.BankName = ord.getPropertyValue('bankName');
      this.LegalName = ord.getPropertyValue('receiverName');
      this.MerchantName = ord.getPropertyValue('merchantName');
    }
  }
}

